import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useLocation } from 'react-router';

import { useTranslation } from '@blocs.i18n';

import { SubnavItem, TalentScoutSubnavPages } from '@minecraft.molecules';
import TalentScoutSearch from './TalentSearch';
import { TalentScoutHistory } from './TalentScoutHistory/TalentScoutHistory';
import { TalentScoutMenu } from './TalentScoutMenu';

export const TALENT_SCOUT_ROUTE = `/talent-scout`;

export const TALENT_SCOUT_HISTORY = `/talent-scout/history`;

export const TalentScout = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const talentScoutMenuItems: SubnavItem[] = [
    {
      page: 'talent-scout',
      label: t('reps:talentScout.title'),
      to: TALENT_SCOUT_ROUTE,
    },
    {
      page: 'scout-history',
      label: t('reps:talentScout.history.title'),
      to: TALENT_SCOUT_HISTORY,
    },
  ];

  const getPageFromPath = (pathname: string): TalentScoutSubnavPages => {
    if (pathname === TALENT_SCOUT_ROUTE) {
      return 'talent-scout';
    }
    return 'scout-history';
  };

  return (
    <>
      <TalentScoutMenu items={talentScoutMenuItems} currentPage={getPageFromPath(pathname)} />
      <Switch>
        <Route exact path={talentScoutMenuItems[0].to}>
          <TalentScoutSearch />
        </Route>
        <Route exact path={talentScoutMenuItems[1].to}>
          <TalentScoutHistory />
        </Route>
      </Switch>
    </>
  );
};
